import axios from './axios';

// Get all collection cash records
export const getAllCollectionCash = async () => {
    const response = await axios.get('/collection-cash');
    return response.data.data;
};

// Get a single collection cash record by ID
export const getCollectionCashById = async (id) => {
    const response = await axios.get(`/collection-cash/${id}`);
    return response.data.data;
};

// Create a new collection cash record
export const addCollectionCash = async (data) => {
    const formData = new FormData();
    
    // Add all text fields
    Object.keys(data).forEach(key => {
        if (key === 'receipt_image' && data[key] instanceof File) {
            formData.append(key, data[key]);
        } else if (key !== 'receipt_image') {
            formData.append(key, data[key]);
        }
    });

    const response = await axios.post('/collection-cash', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return response.data.data;
};

// Update a collection cash record
export const updateCollectionCash = async (id, data) => {
    const formData = new FormData();
    
    // Add all text fields
    Object.keys(data).forEach(key => {
        if (key === 'receipt_image' && data[key] instanceof File) {
            formData.append(key, data[key]);
        } else if (key !== 'receipt_image') {
            formData.append(key, data[key]);
        }
    });

    const response = await axios.put(`/collection-cash/${id}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return response.data.data;
};

// Delete a collection cash record
export const deleteCollectionCash = async (id) => {
    const response = await axios.delete(`/collection-cash/${id}`);
    return response.data;
}; 